import SalesPageComponent from "./components/SalesPageComponent";

import axios from "axios";

const getOrders = async () => {
  const { data } = await axios.get("/api/orders/admin");
  return data
}

const getDeliveryBooks = async () => {
  const { data } = await axios.get("/api/deliveryBooks");
  return data
}

const deleteOrder = async (orderId, itemId) => {
  const { data } = await axios.delete("/api/orders/delete/" + orderId);
  if (data) {
    return data;
  }
}


const fetchCharts = async () => {
  const { data } = await axios.get(`/api/charts`);
  return data;
}

const AdminSalesPage = () => {
  return <SalesPageComponent getOrders={getOrders} deleteOrder={deleteOrder} getDeliveryBooks={getDeliveryBooks} fetchCharts={fetchCharts} />
};

export default AdminSalesPage;

